module.exports = __webpack_public_path__ + "static/images/california-privacy-choices.0aac93922c3560d0f457499ef5dc4ec5.svg";